// This file is autogenerated. Any changes will be overwritten.

const streamlineIconNames = [
  'ai-assist',
  'alexa',
  'align-center',
  'align-left',
  'align-right',
  'amazon',
  'animal-print',
  'api',
  'app',
  'archive-solid',
  'archive',
  'arrow-above-row-right',
  'arrow-bend-left',
  'arrow-down',
  'arrow-left-column',
  'arrow-left',
  'arrow-micro-down',
  'arrow-micro-left',
  'arrow-micro-right',
  'arrow-micro-up-down',
  'arrow-micro-up',
  'arrow-out',
  'arrow-right-column',
  'arrow-right',
  'arrow-up-down',
  'arrow-up',
  'article-solid',
  'article',
  'automation-call',
  'bank',
  'bars',
  'bell-push-notification',
  'bell-solid',
  'bell',
  'bluetooth',
  'boat-cargo',
  'bolt-solid',
  'bolt',
  'book-open',
  'bookmark',
  'box-4',
  'box',
  'branch',
  'browser-code',
  'browser-site',
  'browser',
  'bug',
  'building-2',
  'building-3-solid',
  'building-3',
  'building-globe',
  'bulb',
  'calendar-empty',
  'calendar-now',
  'calendar-range',
  'calendar',
  'car',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'cart-solid',
  'cart',
  'case-medical',
  'case-solid',
  'case',
  'chain',
  'chart-line',
  'chart-pie',
  'chat-check',
  'chat-exclamation-mark',
  'chat-help',
  'chat-quote',
  'chat-transfer',
  'chat-typing',
  'chat-unavailable',
  'chat',
  'chats',
  'check-badge',
  'check-polaris-solid',
  'check',
  'chess',
  'chevron-solid',
  'chevron',
  'circle-mixed-left',
  'circle-mixed-right',
  'circle-solid',
  'circle-stacked-mixed',
  'circle-stacked',
  'circle',
  'clipboard-check',
  'clipboard-medical',
  'clipboard-pencil-solid',
  'clipboard-pencil',
  'clipboard-plus',
  'clipboard',
  'clock-sla',
  'clock-solid',
  'clock',
  'cloud-nodes',
  'cloud',
  'code-search',
  'code',
  'column-delete',
  'condition-critical',
  'condition-satisfactory',
  'confetti',
  'conversation',
  'conveyor-cargo',
  'copy',
  'cpu-chip',
  'credit',
  'csr-agent',
  'csr-connected',
  'currency',
  'custom-column',
  'database-search',
  'dataviz-area-multi',
  'dataviz-area-stacked',
  'dataviz-area',
  'dataviz-bar-clustered',
  'dataviz-bar-stacked',
  'dataviz-bar',
  'dataviz-bell-curve',
  'dataviz-bubble',
  'dataviz-column-clustered',
  'dataviz-column-stacked',
  'dataviz-column',
  'dataviz-combo',
  'dataviz-datetime-field',
  'dataviz-donut',
  'dataviz-flip-counter',
  'dataviz-forecast',
  'dataviz-funnel',
  'dataviz-gauge-linear',
  'dataviz-gauge-progress',
  'dataviz-gauge',
  'dataviz-geo-choropleth',
  'dataviz-heatmap',
  'dataviz-histogram',
  'dataviz-line-horizontal',
  'dataviz-line-multi',
  'dataviz-line-stepped',
  'dataviz-line',
  'dataviz-numeric-field',
  'dataviz-pareto',
  'dataviz-pie',
  'dataviz-pivot-table',
  'dataviz-radar',
  'dataviz-scatter',
  'dataviz-spark',
  'dataviz-sparklines-area',
  'dataviz-sparklines-columns',
  'dataviz-sparklines-line',
  'dataviz-sparklines-pies',
  'dataviz-spline',
  'dataviz-string-field',
  'dataviz-table-with-bars',
  'dataviz-trend-down',
  'dataviz-trend-up',
  'dataviz-waterfall',
  'desktop-pencil',
  'desktop',
  'diamond-minus',
  'diamond',
  'disc-document',
  'disc-nodes',
  'disc-stack-solid',
  'disc-stack',
  'dock',
  'doctor-female',
  'doctor-male',
  'document-doc',
  'document-json',
  'document-pdf',
  'document-xls',
  'document',
  'documents',
  'docusign',
  'dot-9-solid',
  'download',
  'drag',
  'email-open',
  'exchange-case-user',
  'exchange-cases',
  'exchange',
  'expression',
  'eye-off',
  'face-blank',
  'face-happy',
  'face-sad',
  'facebook',
  'factory',
  'farming-wheat',
  'fast-food',
  'fast-forward',
  'field-cursor',
  'field-dot',
  'filetype-text',
  'filter-on',
  'filter',
  'fingerprint-search',
  'flag-check',
  'flag-finish',
  'flag-wave-solid',
  'flag-wave',
  'flashlight',
  'flow-process',
  'folder-closed',
  'folder-empty',
  'folder-hierarchy',
  'folder-nested',
  'folder-search',
  'folder',
  'folders',
  'forward-all',
  'forward',
  'freeze-column',
  'function',
  'galaxy',
  'gear-nodes',
  'gear-play',
  'gear-solid',
  'gear',
  'globe',
  'google',
  'government',
  'graduate',
  'grid-solid',
  'grid',
  'hand-book-open',
  'hand-over-paper',
  'hand',
  'handshake',
  'header',
  'headset',
  'heart-rate',
  'help',
  'hexagons',
  'home-solid',
  'home',
  'house-bed',
  'house-person',
  'indent',
  'infinity',
  'information-solid',
  'information',
  'ios-face-id',
  'ios-finger-id',
  'keyboard',
  'knobs-solid',
  'knobs',
  'language-pack',
  'layers',
  'layout-connected',
  'layout-detached',
  'layout',
  'letter',
  'linkedin',
  'list-number',
  'list',
  'location-solid',
  'location',
  'lock-closed',
  'mail-solid',
  'mail-warning',
  'mail',
  'mcp',
  'megaphone',
  'merge',
  'messages-to-chat',
  'mic-off',
  'mic',
  'micro-arrow-down',
  'micro-arrow-left',
  'micro-arrow-right',
  'micro-arrow-up',
  'minus',
  'mobile-phone',
  'mobius',
  'module',
  'money-atm',
  'money',
  'monitor-lock',
  'more',
  'motherboard',
  'mountain-top',
  'multi-device',
  'navigation',
  'newspaper-fold',
  'newspaper',
  'nodes-down',
  'note-pin',
  'notepad',
  'number-decimal',
  'object-case-multi',
  'object-case-solid',
  'object-case',
  'object-status',
  'offer-list',
  'offer-table',
  'offer',
  'oil-tower',
  'open-new-tab',
  'open',
  'opportunity-refresh',
  'opportunity',
  'os-apple',
  'paper-clip',
  'paper-search',
  'password-lock',
  'pause',
  'paypal',
  'pega',
  'pegasus',
  'pencil',
  'people-group-stakeholders',
  'percentage',
  'person-connection',
  'person-hierarchy-check',
  'person-stars',
  'person',
  'persons-group',
  'phone-call',
  'phone-dial',
  'phone-hangup',
  'phone-in-solid',
  'phone-in',
  'phone-ivr',
  'phone-off',
  'phone-out',
  'phone-split',
  'phone-stethescope',
  'phone-transfer',
  'phone',
  'phonebook',
  'picture-solid',
  'picture',
  'piggybank',
  'play-solid',
  'play',
  'plug-connect',
  'plug-solid',
  'plug',
  'plus',
  'polaris-solid',
  'polaris',
  'prescription',
  'presentation',
  'product',
  'project-plan',
  'project',
  'qr',
  'receipt',
  'reply-all',
  'reply',
  'reset',
  'return',
  'robot-assembly',
  'robot-happy',
  'robot-sad',
  'robot-solid',
  'robot',
  'rocket-solid',
  'rocket',
  'roof-people',
  'rounded-extra-large',
  'rounded-large',
  'rounded-medium',
  'rounded-none',
  'rounded-pill',
  'rounded-small',
  'row-delete',
  'row-insert',
  'row',
  'rule-library-solid',
  'rule-library',
  'rule',
  'scale-down',
  'scale-unequal',
  'scale-up',
  'script',
  'search-analytics-solid',
  'search-analytics',
  'search',
  'selection-cursor',
  'send-solid',
  'send',
  'server',
  'set',
  'sewing-machine',
  'shapes',
  'share-case',
  'share-document',
  'share',
  'shield-currency',
  'shield-lock',
  'shield-solid',
  'shield',
  'shipment-box',
  'shop',
  'shuffle',
  'sigma',
  'slideshow-solid',
  'slideshow',
  'snow',
  'spacing-condensed',
  'spacing-expanded',
  'spacing-standard',
  'speaker-on-sold',
  'speaker-on',
  'speaker',
  'split',
  'stakeholders',
  'star-mixed',
  'star-solid',
  'star',
  'sub-step',
  'table-bolt-solid',
  'table-bolt',
  'table-disc',
  'table',
  'tablet-rate',
  'tag',
  'target-path',
  'target',
  'team',
  'thumbs-down-solid',
  'thumbs-down',
  'thumbs-up-solid',
  'thumbs-up',
  'ticket-movie',
  'times',
  'todo',
  'toolbox-open',
  'toolbox-wrench',
  'train',
  'transform',
  'translate',
  'trash',
  'tribox',
  'truck-cargo',
  'truck-clock',
  'truck',
  'twitter',
  'two-disk-stacks',
  'type-cursor',
  'umbrella',
  'undock',
  'unindent',
  'unwrap',
  'upload',
  'user-check-solid',
  'user-check',
  'user-close-solid',
  'user-close',
  'user-document',
  'user-female-solid',
  'user-female',
  'user-information',
  'user-laptop',
  'user-list-solid',
  'user-list',
  'user-pencil',
  'user-plane',
  'user-plus-solid',
  'user-plus',
  'user-polaris-solid',
  'user-question-mark-solid',
  'user-question-mark',
  'user-search-solid',
  'user-search',
  'user-solid',
  'user-star-solid',
  'user-star',
  'user-unavailable',
  'user',
  'users-solid',
  'users',
  'variable',
  'versions',
  'veterinarian-dog',
  'video-off',
  'video-player',
  'video-solid',
  'video',
  'voice',
  'voicemail',
  'vr-solid',
  'vr',
  'walkie-solid',
  'walkie',
  'wallet-solid',
  'wallet',
  'wand',
  'warn-solid',
  'warn',
  'watch-solid',
  'watch',
  'waypoint-solid',
  'waypoint',
  'webcam-solid',
  'webcam',
  'whatsapp',
  'widget',
  'wifi-none',
  'wifi-off',
  'wifi',
  'wizard-solid',
  'wizard',
  'wrap',
  'wrench-solid',
  'wrench',
  'youtube'
] as const;

export default streamlineIconNames;

export type StreamlineIconName = (typeof streamlineIconNames)[number];
